import { render, staticRenderFns } from "./UnreadMessages.vue?vue&type=template&id=b0537f92&scoped=true&"
import script from "./UnreadMessages.vue?vue&type=script&lang=ts&"
export * from "./UnreadMessages.vue?vue&type=script&lang=ts&"
import style0 from "./UnreadMessages.vue?vue&type=style&index=0&id=b0537f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0537f92",
  null
  
)

export default component.exports